import { Tabs } from '~/shared/components/tabs/Tabs';
import { PageLayout } from '~/shared/PageLayout';
import { CheckIcon } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { useSelectedTab, type NavigationTab } from '~/shared/components/tabs/useSelectedTab';

const tabs: NavigationTab[] = [
	{ id: '/qa', label: 'Overview', href: '/qa' },
	{ id: '/qa/poc-reviews', label: 'PoC Reviews', href: '/qa/poc-reviews' },
	{ id: '/qa/visit-reviews', label: 'Visits', href: '/qa/visit-reviews' }
];
export function QaPage() {
	const selectedTab = useSelectedTab(tabs);

	return (
		<PageLayout pageHeader={{ title: 'QA', description: 'Manage quality assurance.', TitleIcon: CheckIcon }}>
			<Tabs selectedKey={selectedTab}>
				<Tabs.TabList>
					{tabs.map(tab => (
						<Tabs.Tab key={tab.id} id={tab.id} href={tab.href}>
							{tab.label}
						</Tabs.Tab>
					))}
				</Tabs.TabList>
				<Tabs.TabPanel id={selectedTab}>
					<Outlet />
				</Tabs.TabPanel>
			</Tabs>
		</PageLayout>
	);
}
